module.exports = __webpack_public_path__ + "static/media/Sports Edition _ 4-11-2015.2445482e.jpg";